import { render, staticRenderFns } from "./OffMarketIntroduction.vue?vue&type=template&id=075cd6a0&"
import script from "./OffMarketIntroduction.vue?vue&type=script&lang=ts&"
export * from "./OffMarketIntroduction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports